/**
 * Macro #26 · Increment 2 — WebGL availability probe (PURE, NO three).
 *
 * Lives OUTSIDE the lazy 3D chunk so the public overlay / editor can decide to
 * show the real 2D fallback BEFORE ever importing `three`. A genuine failure
 * path — never a black rectangle or an infinite loader.
 */
export function isWebGLAvailable(): boolean {
  if (typeof document === "undefined") return false;
  try {
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl2") ||
      canvas.getContext("webgl") ||
      canvas.getContext("experimental-webgl");
    return Boolean(gl);
  } catch {
    return false;
  }
}
